// src/components/user/topnavbar/UserTopNavbar.jsx
import React, { useState, useRef, useEffect } from 'react';
import { 
  FiMenu, FiSearch, FiChevronDown, FiUser, FiX 
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../../../src/assets/css/useradmin/usertopnavbar/UserTopNavbar.css";

const UserTopNavbar = ({ onToggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  // Get page title
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/my-rentals')) return 'My Rentals';
    if (path.includes('/maintenance')) return 'Maintenance';
    if (path.includes('/booking-history')) return 'Booking History';
    if (path.includes('/messages')) return 'Messages';
    if (path.includes('/payments')) return 'Payments';
    if (path.includes('/favorites')) return 'Favorites';
    if (path.includes('/reviews')) return 'Reviews & Ratings';
    if (path.includes('/profile')) return 'Profile';
    if (path.includes('/notifications')) return 'Notifications';
    if (path.includes('/support')) return 'Support';
    return 'Dashboard';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = () => setIsDropdownOpen(!isDropdownOpen);

  const handleProfile = () => {
    navigate('/user/profile');
    setIsDropdownOpen(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/user/${searchQuery}`);
    }
  };

  return (
    <nav className="user-admin-topnavbar">
      <div className="user-topnavbar-left">
        {/* Hamburger Menu */}
        <button 
          className="user-hamburger-btn" 
          onClick={onToggleSidebar}
          aria-label="user-Toggle Sidebar"
        >
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Page Title */}
        <h1 className="user-page-title">{getPageTitle()}</h1>
      </div>

      <div className="user-topnavbar-right">
        {/* Search Bar */}
        <form className="user-search-container" onSubmit={handleSearch}>
          <FiSearch className="user-search-icon" />
          <input
            type="text"
            className="user-search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>

        {/* User Profile Dropdown */}
        <div className="user-admin-profile-container" ref={dropdownRef}>
          <button 
            className="user-admin-profile-btn" 
            onClick={handleDropdownToggle}
            aria-label="Admin Menu"
          >
            <div className="user-admin-avatar">U</div>
            <span className="user-admin-name">User Admin</span>
            <FiChevronDown 
              className={`chevron-icon ${isDropdownOpen ? 'rotate' : ''}`} 
              size={18} 
            />
          </button>

          {isDropdownOpen && (
            <div className="user-admin-dropdown">
              <div className="user-dropdown-header">
                <div className="user-dropdown-avatar">U</div>
                <div className="user-dropdown-info">
                  <h4 className="user-dropdown-name">User Admin Panel</h4>
                  <p className="user-dropdown-email">useradmin@agrirent.com</p>
                </div>
              </div>
              
              <div className="user-dropdown-divider"></div>
              
              <button className="user-dropdown-item" onClick={handleProfile}>
                <FiUser size={18} />
                <span>Profile</span>
              </button>
              
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default UserTopNavbar;